import { useQuery } from 'react-query'
import { getMusics, getMusicByUrl, getMusicByCode } from 'services/requests/musics'
import { useGetResourcesByUrlArray } from './base'
import { Voice } from 'types/Voice'


export const useGetMusics = (params) => {
	const defaultParams = {
		page: 1,
		itemsPerPage: 30
	}

	return useQuery(
		['musics', {...defaultParams, ...params}],
		() => getMusics({...defaultParams, ...params})
	)
}

export const useGetMusicByUrlArray = ( voices ) => {
	return useGetResourcesByUrlArray<Voice>(getMusicByUrl, voices)
}

export const useGetMusicByCode = ( code ) => {
	return useQuery(['music', code],() => getMusicByCode(code))
}
